import React, { useEffect, useState } from "react";
import modalCss from "components/ui/Modal/Modal.module.css";
import { Modal } from "react-bootstrap";
import Grid from "components/ui/Grid/Grid";
import Button from "components/ui/Button/Button";
import InputMaterial, { CUITMask } from "components/ui/Input/InputMaterial";
import useQueryQueue from "components/hooks/useQueryQueue";
import Table from "components/ui/Table/Table";
import Formato from "components/helpers/Formato";
import styles from "./Localizar.module.css";
import moment from "moment"; 

const onCloseDef = () => {};

const InputMaterialDetail = (p) => (
	<InputMaterial variant="standard" padding="0rem 0.5rem" size="small" {...p} />
);

const Localizar = ({ onClose = onCloseDef }) => {
	const pushQuery = useQueryQueue((action, params) => {
		switch (action) {
			case "GetAfiliados": {
				return {
					config: {
						baseURL: "Afiliaciones",
						endpoint: "/Afiliado/GetAfiliadosWithSpec",
						method: "POST",
					},
					params,
				};
			}
			case "GetAfiliadoByCUILValidado": {
				return {
					config: {
						baseURL: "Afiliaciones",
						endpoint: "/Afiliado/GetAfiliadoByCUILValidado",
						method: "GET",
					},
					params,
				};
			}
			default:
				return null;
		}
	});

	const [state, setState] = useState({
		nroAfiliado: 0,
		documento: 0,
		cuil: 0,
	});

	const [afiliados, setAfiliados] = useState({
		loading: null,
		params: {},
		pagination: { index: 1, size: 2, count: 0 },
		data: [],
		selection: { selected: [] },
		error: null,
		selected: {}
	});

	useEffect(() => {
		if (!afiliados.loading) return;

		if (afiliados.params?.cuil) {
			pushQuery({
				action: "GetAfiliadoByCUILValidado",
				params: { CUIL: afiliados.params.cuil },
			onOk: (data) => {
				let arr = [];
				if (Array.isArray(data)) arr = data;
				else if (data) arr = [data];

				const CUIL_LENGTH = 11;
					const filtered = arr.filter((r) => {
						const val = r?.cuilValidado;
						if (val == null) return false;
						const digits = String(val).replace(/\D/g, "");
						return Number(val) !== 0 && digits.length === CUIL_LENGTH;
					});
					setAfiliados((o) => ({
						...o,
						loading: null,
						pagination: { index: 1, size: filtered.length, count: filtered.length },
						data: filtered,
						selection: { selected: filtered.length ? [filtered[0].id] : [] },
						selected: filtered.length ? filtered[0] : {},
						error: null,
					}));
				},
				onError: (e) => setAfiliados((o) => ({ ...o, loading: null, data: [], selected: {}, error: e })),
			});
			return;
		}

		pushQuery({
			action: "GetAfiliados",
			config: {
				body: {
					...afiliados.params,
					soloActivos: true,
					pageIndex: afiliados.pagination.index,
					pageSize: afiliados.pagination.size,
					ambitoTodos: {ids: [0]}
				},
			},
			onOk: ({ index, size, count, data }) => {
				setAfiliados((o) => ({
						...o,
						loading: null,
						pagination: { index, size, count },
						data,
						selection: {
							selected: ((a) => (a.length ? a : data.length ? [data[0].id] : []))(
								data
									.filter((r) => o.selection.selected.includes(r.id))
									.map((r) => r.id)
							),
						},
						selected: data.length ? data[0] : {},
						error: null,
					}));
			},
			onError: (e) =>
				setAfiliados((o) => ({ ...o, loading: null, data: [], selected: {}, error: e }))
		});
	}, [pushQuery, afiliados]);

	return (
		<Modal size="lg" centered show>
			<Modal.Header className={modalCss.modalCabecera}>
				<Grid width="full" justify="center">
					<h4>Localiza Afiliado</h4>
				</Grid>
			</Modal.Header>
			<Modal.Body>
				<Grid col width="full" gap="10px">
					<Grid>Buscar por...</Grid>
					<Grid width="full" gap="inherit">
						<InputMaterial
							label="Nro. Afiliado"
							type="number"
							value={state.nroAfiliado}
							onChange={(v) => setState((o) => ({ ...o, nroAfiliado: v }))}
						/>
						<InputMaterial
							label="CUIL"
							type="number"
							value={state.cuil}
							onChange={(v) => setState((o) => ({ ...o, cuil: v }))}
						/>
						<InputMaterial
							label="Documento"
							type="number"
							value={state.documento}
							onChange={(v) => setState((o) => ({ ...o, documento: v }))}
						/>
						<Grid style={{ minWidth: "200px" }}>
							<Button
								className="botonAmarillo"
								onClick={() => {
									const cambios = {
										params: {},
										data: [],
										selection: { selected: [] },
										selected: {},
									};

									if (state.nroAfiliado)
										cambios.params.nroAfiliado = state.nroAfiliado;
									if (state.documento) cambios.params.documento = state.documento;
									if (state.cuil) cambios.params.cuil = state.cuil;

									if (Object.keys(cambios.params).length)
										cambios.loading = "Cargando...";
									else
										cambios.error = { message: "Debe ingresar algún parámetro " };

									setAfiliados((o) => ({ ...o, ...cambios }));
								}}
							>
								Localiza
							</Button>
						</Grid>
					</Grid>
					<Table
						remote
						loading={!!afiliados.loading}
						mostrarBuscar={false}
						keyField="id"
						data={afiliados.data}
						pagination={{
							...afiliados.pagination,
							onChange: (c) =>
								setAfiliados((o) => ({
									...o,
									loading: "Cargando",
									pagination: { ...o.pagination, ...c },
								})),
						}}
						selection={{
							...afiliados.selection,
							onSelect: (row, isSelect, index, e) =>
								setAfiliados((o) => ({
									...o,
									selection: { ...o.selection, selected: [row.id] },
									selected: row
								}))
						}}
						noDataIndication={
							afiliados.loading ||
							((e) => (e ? <span style={{ color: "red" }}>{e}</span> : null))(
								[afiliados.error?.code, afiliados.error?.message]
									.filter((r) => r)
									.join(" ")
							) ||
							"No existen datos para mostrar"
						}
						columns={[
							{
								dataField: "nroAfiliado",
								text: "Nro. Afil.",
								style: { textAlign: "center" },
								headerStyle: () => ({ width: "7rem", textAlign: "center" }),
							},
							{
								dataField: "nombre",
								text: "Nombre",
							},
							{
								dataField: "seccional",
								text: "Seccional",
								formatter: (v, row) => `${row.seccionalCodigo} ${v}`,
							},
		
						]}
					/>
					<Grid
						className={[styles.fondo, styles.grupo].join(" ")}
						col
						width="full"
						gap="inherit"
					>
						<Grid className={styles.titulo} width="full">
							Datos del afiliado
						</Grid>
						<Grid col width="full" gap="inherit" style={{ padding: "0rem 1rem" }}>
							<Grid width="full" gap="inherit">
								<InputMaterialDetail
									label="Nro. afiliado"
									value={afiliados.selected.nroAfiliado}
								/>
							<InputMaterialDetail
								label="CUIL"
								mask={CUITMask}
								value={afiliados.selected.cuilValidado != 0 ? afiliados.selected.cuilValidado : afiliados.selected.cuil}
								/>
								<InputMaterialDetail
									label="Documento"
									value={[
										afiliados.selected.afipTipoDocumento,
										Formato.DNI(afiliados.selected.afipNumeroDocumento),
										]
										.filter((r) => r)
										.join(" ")}
								/>
							</Grid>
							<Grid width="full" gap="inherit">
								<InputMaterialDetail  style={{"-webkit-text-stroke": "medium"}} label="Nombre" value={afiliados.selected?.nombre}/>
								<InputMaterialDetail label="Seccional" value={!!afiliados.selected?.seccionalCodigo && !!afiliados.selected?.seccional ? `${afiliados.selected?.seccionalCodigo} ${afiliados.selected?.seccional}` : ""} />
							</Grid>
					<Grid width="full" gap="inherit">
						<InputMaterialDetail label="Estado" value={afiliados.selected?.estadoSolicitud} />
						<InputMaterialDetail
							label="Fecha Ingreso"
							value={afiliados.selected?.fechaIngreso
								? moment(afiliados.selected.fechaIngreso).format("yyyy-MM-DD")
								: ""}
						/>
						{afiliados.selected?.fechaEgreso && (
							<InputMaterialDetail
								label="Fecha Egreso"
								value={moment(afiliados.selected.fechaEgreso).format("yyyy-MM-DD")}
							/>
						)}
					</Grid>
					{afiliados.selected?.estadoSolicitudObservaciones && (
						<InputMaterialDetail
							label="Observación"
							value={afiliados.selected.estadoSolicitudObservaciones}
						/>
					)}							
						</Grid>
					</Grid>
				</Grid>
			</Modal.Body>
			<Modal.Footer>
				<Grid width="full" justify="evenly" gap="inherit">
					<Grid width="200px" gap="inherit">
						<Button className="botonAmarillo" onClick={onClose}>
							Cierra
						</Button>
					</Grid>
				</Grid>
			</Modal.Footer>
		</Modal>
	);
};

export default Localizar;
